const PERSONAL_EMAIL_DOMAINS = new Set([
  'aol.com',
  'bol.com.br',
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.com.br',
  'icloud.com',
  'live.com',
  'live.com.br',
  'mac.com',
  'me.com',
  'msn.com',
  'outlook.com',
  'outlook.com.br',
  'terra.com.br',
  'uol.com.br',
  'yahoo.com',
  'yahoo.com.br',
]);

export const isPersonalEmailDomain = (email: string): boolean => {
  const domain = email.split('@').pop()?.toLocaleLowerCase('pt-BR');

  return !!domain && PERSONAL_EMAIL_DOMAINS.has(domain);
};
